import React, {Fragment, useEffect, useState} from 'react';
import './AdminDashboardPageBody.scss';
import PageBodyWrapper from "root/PageBodyWrapper";

import TeacherDashboardContainer from "root/Dashboard/TeacherDashboardContainer";
import { useParams } from "react-router-dom";

const TeacherDashboardPageBody = (props) =>
{
    const { provider_id } = useParams();

    return (
        <Fragment>
            <PageBodyWrapper title='Dashboard'>
                <div className='manage-grid-rows'/>
                <TeacherDashboardContainer provider_id={provider_id}/>
            </PageBodyWrapper>
        </Fragment>
    )
}

export default TeacherDashboardPageBody;
